export default {
	// baseURL: "http://localhost:2100/dashboardAPI/v1",
	baseURL: "https://dashapi.atomx.in/dashboardAPI/v1",
	// baseURL: "http://fnb.atomx.in:2100/armourxAPI/v1/ArmorX/",
}
